import Grid from '@mui/material/Grid2';
import SpinButton from 'Components/Buttons/Button';
import CheckBox from 'Components/Forms/CheckBox';
import DateTime from 'Components/Forms/DateTime';
import FileInput from 'Components/Forms/FileInput';
import Text from 'Components/Forms/Input';
import TextArea from 'Components/Forms/InputArea';
import Number from 'Components/Forms/InputNumber';
import Password from 'Components/Forms/Password';
import Select from 'Components/Forms/Select';
import SelectMultiple from 'Components/Forms/SelectMultiple';
import { initializeForm, initializeFormCleanUp } from 'ducks/formInitializer';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { formInitialDataExtractor } from 'utils/forms/utils';

const fieldTranslate = {
    'checkBox': CheckBox,
    'dateTime': DateTime,
    'file': FileInput,
    'number': Number,
    'password': Password,
    'select': Select,
    'selectMultiple': SelectMultiple,
    'text': Text,
    'textArea': TextArea
};

const Component = props => {
    const { buttonLabel = 'Save', formInitialValues, formSchema, handleSubmit, isSubmitting, loading = false, onSubmit } = props;

    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            dispatch(initializeFormCleanUp());
        };
    }, [dispatch]);

    useEffect(() => {
        if (formInitialValues) {
            dispatch(initializeForm(formInitialDataExtractor(formInitialValues, formSchema)));
        }
        // `formSchema` is an array literal rebuilt by every page that renders a form, so it is
        // never referentially stable; re-initializing the form on each render would wipe what
        // the user is typing. Stabilizing it means memoizing at every call site.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formInitialValues]);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Grid xs={12}>
                {
                    formSchema.map(field => {
                        if (field.type === 'label') {
                            return (
                                <div
                                    key={field.name}
                                    style={{ fontSize: '0.65rem', marginTop: 16, marginBottom: 4, color: 'rgba(0, 0, 0, 0.6)' }}
                                >
                                    {field.label}
                                </div>
                            );
                        }
                        return (
                            <Field
                                accept={field.accept}
                                component={fieldTranslate[field.type]}
                                disabled={field.disabled}
                                key={field.name}
                                label={field.label}
                                name={field.name}
                                normalize={field.normalize}
                                placeholder={field.placeholder}
                                rows={field.rows}
                                schema={field}
                                validate={field.validate}
                            />
                        );
                    }
                    )
                }
            </Grid>
            <Grid container style={{ padding: '20px' }} xs={12}>
                <Grid>
                    <SpinButton label={buttonLabel} loading={loading} size="small" submitting={isSubmitting} type="submit"/>
                </Grid>
            </Grid>
        </form>
    );
};

Component.propTypes = {
    formSchema: PropTypes.arrayOf(PropTypes.object).isRequired,
    // TODO: formValues being received as props, but BaseForm could be connected to the store
    formValues: PropTypes.object, // Object with values on form inputs
    handleSubmit: PropTypes.func, // From redux forms
    loading: PropTypes.bool,
    isSubmitting: PropTypes.bool, //alias, redux Forms use submitting (needs promise from onSubmit to work correctly)
    onSubmit: PropTypes.func
};

const mapStateToProps = state => ({
    initialValues: state.formInitializers
});

export default connect(mapStateToProps)(reduxForm({ form: 'form', enableReinitialize: true })(Component));
